<template>
    <div class="table-container">

        <div class="table-responsive datatable-vue">
            <b-table
                show-empty
                stacked="md"
                @change="emitChange"
                :items="state.tableData"
                :fields="fields"
            >
                <!-- <template #cell(id)="row">
                    {{ row.index+1 }}
                </template> -->

             <template #cell(name)="row">
                 <div v-if="row.item.checkLabel">
                    <input class="form-control" type="text" placeholder="Enter label name" v-model="row.item.product_id">
                </div>
                <div v-else>
                    <select class="form-control" v-model="row.item.product_id" @change="getItems(row.item.product_id, row.index)">
                        <option disabled value="">Select item</option>

                        <option v-for="(q_item, index) in state.quotation_items" :key="index" :value="q_item.id">
                            {{ q_item.name }}
                        </option>

                    </select>
                </div>
                <small v-if="state.errors[row.index]" class="text-danger">
                    {{ state.errors[row.index] }}
                </small>
              
                </template>

                <template #cell(description)="row">
                <div v-if="row.item.checkLabel">
                </div>
                <div v-else>
                    <input class="form-control" type="text" placeholder="Enter description" disabled  v-model="row.item.description">
                </div>
            </template>

            <template #cell(rate)="row">
                <div v-if="row.item.checkLabel">
                </div>
                <div v-else>
                    <input @change="calculateAmount(row.item.id)" class="form-control" type="number" disabled   v-model="row.item.rate">
                </div>
            </template>

            <template #cell(quantity)="row">
                <div v-if="row.item.checkLabel">
                </div>
                <div v-else>
                    <input @change="calculateAmount(row.item.id)" class="form-control" type="number" placeholder="Enter item quantity" v-model="row.item.quantity">
                </div>
            </template>

            <template #cell(unit_price)="row">
                <div v-if="row.item.checkLabel">
                </div>
                <div v-else>
                    <input class="form-control" type="number"  disabled v-model="row.item.unit_price" placeholder="Enter unit cost">
                </div>
            </template>

            <template #cell(action)="row" v-if="!onlyUpdate">
                <button @click="removeItem(row.item.id)" class="btn btn-primary" type="submit" v-if="!onlyUpdate">Delete</button>
            </template>

                
            </b-table>
        </div>

        <div style="display: flex; gap: 12px;">
            <b-button variant="primary" @click="addItem" v-if="!onlyUpdate">Add Item</b-button>
            <b-button variant="primary" @click="addLabel" v-if="!onlyUpdate">Add Label</b-button>
        </div>
    </div>
</template>
  
<script>
import { computed, defineComponent, reactive } from "vue";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default defineComponent ({
    name: "item-table",

    props:{
        tableData: {
            type: Array,
            default: () => []
        },
        onlyUpdate: {
            type: Boolean,
            default: false
        }
    },

    setup(props, { emit }) {
        const state = reactive({
            errors:[],
            currentId: computed(() => state.tableData.length),
            tableData: props.tableData || [
                {
                    id: 1,
                    name: null,
                    product_id: null,
                    description: null,
                    rate: null,
                    quantity: null,
                    unit_price: null,
                    checkLabel: false
                },
            ],
           
            quotation_items: []
        });

        // Calculate Amount
        const calculateAmount = (id) => {
            state.tableData.map((item) => {
                if (item.id === id) {
                    item.rate = item.unit_price * item.quantity;
                    return item;
                }
                return item;
            });

            emitChange();
        };

        const baseFields = [
            { key: 'name', label: 'Item', sortable: false },
            { key: 'description', label: 'Description', sortable: false },
            { key: 'unit_price', label: 'Unit Price', sortable: false },
            { key: 'quantity', label: 'Quantity', sortable: false },
            { key: 'rate', label: 'Amount', sortable: false }
            ]

            const fields = computed(() => {
                if (props.onlyUpdate) {
                    return baseFields
            }

            return [
                ...baseFields,
                { key: 'action', label: 'Action', sortable: false } // ✅ only when not update
            ]
        })
 
    
        // Add item
        const addItem = () => {
            state.tableData.push({
                id: state.currentId + 1,
                name: null,
                product_id: null,
                description: null,
                rate: null,
                quantity: null,
                unit_price: null,
                checkLabel: false

            });
        };

        // Add Label
        const addLabel = () => {
            state.tableData.push({
                id: state.currentId + 1,
                name: null,
                product_id: null,
                description: null,
                rate: null,
                quantity: null,
                unit_price: null,
                checkLabel: true
            });
        };



        // Get Item
        const getItems = (productId, index) => {

            const exists = state.tableData.some((item, i) =>
                item.product_id === productId && i !== index
            )
            if (exists) {
                Swal.fire({
                        title: "Error!",
                        text: "Product already exists.",
                        icon: "warning"
                });
                state.tableData.splice(index, 1)
                return
            }
            const product = state.quotation_items.find(
                item => item.id === productId
            )

            if (!product) return

            Object.assign(state.tableData[index], {
                name: product.name,
                product_id: product.id,
                description: product.description,
                rate: product.offer_price,
                quantity: 1,
                unit_price: product.offer_price
            })

            calculateId()
            emitChange()
        }

        // Remove Item
        const removeItem = (id) => {
            const temp = state.tableData.filter((item) => item.id !== id);
            state.tableData = temp;
            calculateId();
            emitChange();
        };

        // Calculate ID
        const calculateId = () => {
            let id = 0;
            state.tableData.map((item) => {
                id++;
                item.id = id;
                return item;
            });
        };

        // Emit change
        const emitChange = () => {
            // console.log(state.details)
            emit("itemsUpdated", state.tableData);
        };
    
        return {
            state,
            fields,
            addItem,
            addLabel,
            getItems,
            removeItem,
            calculateAmount,
            emitChange,
        };
    }, 

    mounted() {
        this.$store.dispatch("inventory/fetchProductWithoutPG").then(result => {
            this.state.quotation_items = result
        })
    }
})
</script>
  
<style scoped>
.table-container {
    width: 100%;
    display: flex;
    flex-direction: column;
}
</style>
  